import { render } from "./ApiDocView.vue?vue&type=template&id=6b3486ee&scoped=true&ts=true"
import script from "./ApiDocView.vue?vue&type=script&lang=ts"
export * from "./ApiDocView.vue?vue&type=script&lang=ts"

import "./ApiDocView.vue?vue&type=style&index=0&id=6b3486ee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3486ee"]])

export default __exports__